import type { LegsQueryOptionsSignal } from './types';

/**
 * WeakMap associating icon DOM elements with their query options Signal.
 *
 * This registry enables communication between AG Grid cell renderers and the
 * LegsHoverCardProvider without requiring React Context or string-based lookups.
 *
 * Key benefits:
 * - Key: The icon DOM element itself (no string ID management needed)
 * - Automatic cleanup when element is removed from DOM (WeakMap behavior)
 * - Value: Signal allows reactive updates when row data changes
 * - Query re-runs are controlled by queryKey (managed by the factory)
 */
export const legsQueryOptionsRegistry = new WeakMap<Element, LegsQueryOptionsSignal>();
